import React, { memo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { smallMediaQuery } from '../../common/utilities/sizeHelpers';
import { translate } from  '../../common/translation/translate.js';

export const PollenForecast = memo(({ pollenTechDiscussionToday, pollenTechDiscussion }) => {
    return (
        <Container>
            <ForecastCard left={true}>
                <ForecastTitle>
                    {translate('today')}
                </ForecastTitle>
                <ForecastSummary>
                    {pollenTechDiscussionToday}
                </ForecastSummary>
            </ForecastCard>
            <ForecastCard left={false}>
                <ForecastTitle>
                    {translate('outlook')}
                </ForecastTitle>
                <ForecastSummary>
                    {pollenTechDiscussion}
                </ForecastSummary>
            </ForecastCard>
        </Container>
    );
});

PollenForecast.displayName = 'PollenForecast';
PollenForecast.propTypes = {
    pollenTechDiscussionToday: PropTypes.string,
    pollenTechDiscussion: PropTypes.string
};

const Container = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 10px;

    @media ${smallMediaQuery} {
        display: inline-block;
    }
`;

const ForecastCard = styled.div`
    padding: 20px;
    background-color: white;
    border-radius: 2px;
    width: 50%;
    min-height: 250px;
    margin-right: ${({left}) => left ? '10px' : '0'};
    white-space: normal;

    @media ${smallMediaQuery} {
        width: 100%;
        min-height: 175px;
        margin-top: ${({left}) => left ? '' : '10px'};
    }
`;

const ForecastTitle = styled.div`
    font-size: 18px;
    font-weight: 600;
    color: #455560;
`;

const ForecastSummary = styled.div`
    margin-top: 12px;
    font-size: 15px;
    font-weight: 400;
    color: #7E868C;
`;


